import { FC } from 'react';
import Button, { ButtonVariant } from 'components/common/Button/Button';
import Toolbar from 'components/common/Toolbar/Toolbar';
import { Markup } from 'interweave';
import ELEMENT from 'common/element';
import { LogObject } from '../LogSample/LogSample';
import './styles.scss';

type ParserOutputProps = {
  onUpdateParserOutput: (log?: LogObject) => void;
  parserOutputContent: string;
  activeLogLine?: LogObject;
  className?: string;
};

const ParserOutput: FC<ParserOutputProps> = ({
  onUpdateParserOutput,
  parserOutputContent,
  activeLogLine,
  className,
}: ParserOutputProps) => {
  const leftItems = [
    <div className="SectionHeader" data-test-id={ELEMENT.parserOutputHeader}>
      Parser Output
    </div>,
  ];
  const rightItems = [
    <Button
      variant={ButtonVariant.PRIMARY}
      size="sm"
      onClick={(): void => {
        onUpdateParserOutput(activeLogLine);
      }}
      testId={ELEMENT.testParserButton}
    >
      Test Parser
    </Button>,
  ];

  return (
    <div className={className}>
      <Toolbar leftItems={leftItems} rightItems={rightItems} />
      <div data-test-id={ELEMENT.parserOutputContent} className="ParserPage__ParserOutputContent">
        {parserOutputContent ? (
          <Markup content={parserOutputContent} noWrap disableLineBreaks />
        ) : (
          <div className="ParserPage__NoContentMessage" data-test-id={ELEMENT.logSampleContainerNoContentMessage}>
            Click &quot;Test Parser&quot; to update
          </div>
        )}
      </div>
    </div>
  );
};

export default ParserOutput;
